var config = require('../../../../config.js');
angular.module('ikeweb.user').controller('ChoosePasswordController', ['$scope', '$stateParams',
    function($scope, $stateParams) {
        $scope.formAction = config.parse.path + '/apps/' + config.parse.appid + '/request_password_reset';
        $scope.error = $stateParams.error;
        $scope.username = $stateParams.username;
        $scope.token = $stateParams.token;
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/password/forgot/choose.password.controller.js
// module id = 474
// module chunks = 0